import type { SVGProps } from 'react';

export default function IconParkOutlineClose(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="m8 8l32 32M8 40L40 8"
      ></path>
    </svg>
  );
}
